import { removeSearchParam } from 'utils/update-query-params';
import { isDevelopment } from 'utils/environment';
import { NextWebVitalsMetric } from 'next/app';

export function trackCurrentPageView(url: string) {
  if (!isDevelopment || !url) return;
  const location = new URL(url, window.location.origin);
  const pixelPagePath = removeSearchParam(removeSearchParam(location.href, 'latitude'), 'longitude');
  console.debug(`Analytics\tEvent=Pageview,pagePath=${location.pathname},pixelPagePath=${pixelPagePath}`);
}

export function trackOffMarketPage() {
  if (!isDevelopment) return;
  console.debug('Analytics\tEvent=off-market-pageview,pagePath=' + window.location.pathname);
}

const ratingColors: Record<string, string> = {
  good: 'color: green',
  'needs-improvement': 'color: orange',
  poor: 'color: red',
};

export function trackWebVitals(metric: NextWebVitalsMetric & { delta?: number; navigationType?: string; rating?: string }) {
  if (!isDevelopment) return;

  const messageMappings: Record<NextWebVitalsMetric['name'], string> = {
    FCP: 'FCP: First Contentful Pain:',
    LCP: 'LCP: Largest Contentful Paint:',
    FID: 'FID: First Input Delay:',
    TTFB: 'TTFB: Time To First Byte:',
    CLS: 'CLS: Cumulative Layout Shift:',
    INP: 'INP: Interaction to Next Paint:',
    'Next.js-hydration': 'Next.js Hydration:',
    'Next.js-route-change-to-render': 'Next.js Route Change to Render:',
    'Next.js-render': 'Next.js Render:',
  };
  const ratingColor = ratingColors[metric.rating];
  const webVitalsMessage = `${messageMappings?.[metric.name] || `Unrecognized Metric: ${metric.name}`} ${Math.round(metric.value)/ 1000}s %c${metric.rating?.toUpperCase()}`;
  console.log(webVitalsMessage, ratingColor);
}

export function trackDelayedPageView() {
  if (!isDevelopment) return;
  console.debug('Analytics\tEvent=delayed-pageview,pagePath=' + window.location.pathname);
}

export function trackAppLoadedEvent() {
  if (!isDevelopment) return;
  console.debug('Analytics\tEvent=app-loaded');
}

export function trackEvent(event: string, category = 'All', label?: string, value?: number) {
  if (!isDevelopment) return;
  console.debug(`Analytics\tEvent=${event},category=${category},label=${label},value=${value}`);
}

export function trackConnectionRequest() {
  if (!isDevelopment) return;
  console.debug('Analytics\tEvent=Pageview,pagePath=/connection-request-submission');
}

export function trackGrowthbookEvent(experimentId: string, variationId: number) {
  if (!isDevelopment) return;
  console.debug(`Analytics\tEvent=experiment_viewed,event_category=experiment,experiment_id=${experimentId},variation_id=${variationId}`);
}